var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4268 23.9998C12.3444 23.9998 12.2629 23.9827 12.1874 23.9497C12.1119 23.9166 12.044 23.8683 11.9881 23.8078L0.158738 11.0118C0.07988 10.9265 0.0276024 10.8201 0.00830289 10.7055C-0.0109966 10.5909 0.00351918 10.4732 0.0500738 10.3668C0.0966285 10.2604 0.173203 10.1698 0.270424 10.1062C0.367645 10.0426 0.481297 10.0088 0.597469 10.0088H6.29148C6.37697 10.0088 6.46146 10.0271 6.53926 10.0626C6.61706 10.098 6.68635 10.1497 6.74246 10.2142L10.6959 14.7625C11.1231 13.8492 11.9502 12.3285 13.4016 10.4754C15.5473 7.73599 19.5384 3.70711 26.3666 0.0701142C26.4986 -0.000166433 26.6522 -0.018407 26.7969 0.0189944C26.9417 0.0563958 27.0672 0.14672 27.1486 0.272132C27.23 0.397544 27.2615 0.548927 27.2367 0.696389C27.212 0.843851 27.1328 0.976673 27.0149 1.06863C26.9889 1.089 24.3561 3.16227 21.3262 6.9598C18.5376 10.4545 14.8307 16.1688 13.0066 23.5459C12.9746 23.6755 12.9001 23.7907 12.7949 23.873C12.6898 23.9553 12.5602 24 12.4267 24L12.4268 23.9998Z",
    fill: "#2DCBE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4ec1424c9f5030fea48bbb0477998045.svg";
export { ForwardRef as ReactComponent };